import React, { useState } from 'react';
import AuthModal from './auth/AuthModal';

interface LoginRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function LoginRequiredModal({ isOpen, onClose }: LoginRequiredModalProps) {
  const [showAuthModal, setShowAuthModal] = useState<null | 'login' | 'register'>(null);

  const handleLoginSuccess = () => {
    // Close both the auth modal and the login required modal
    setShowAuthModal(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent">
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-sm w-full relative">
          <button
            className="absolute top-2 right-2 text-zinc-500 hover:text-zinc-800"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
          <h2 className="text-xl font-bold text-zinc-900 mb-4 text-center">Login Required</h2>
          <p className="text-zinc-700 mb-6 text-center">You need to be logged in to continue.</p>
          <div className="flex flex-col gap-3">
            <button
              className="bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors"
              onClick={() => setShowAuthModal('login')}
            >
              Sign In
            </button>
            <button
              className="bg-zinc-100 text-zinc-900 py-2 rounded-md font-semibold hover:bg-zinc-200 transition-colors border border-zinc-300"
              onClick={() => setShowAuthModal('register')}
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
      <AuthModal
        isOpen={!!showAuthModal}
        onClose={() => setShowAuthModal(null)}
        mode={showAuthModal || 'login'}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
} 